<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-12 09:19:02
 * @LastEditTime: 2022-03-03 18:22:42
-->
<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-button
        v-if="Permission.indexOf(260) !== -1"
        type="primary"
        size="mini"
        @click="addContact"
        >{{ $t("lang.alarmContact.add") }}</el-button
      >
    </div>
    <TableComponent
      :Columns="Columns"
      :data="contactList"
      :ColuumnsButton="ColuumnsButton"
      :ColuumnsButtonWidth="240"
      @editcontactList="editcontactList"
      @handleSelectionChange="handleSelectionChange"
      @deleteContact="contactDelete"
      @sortChange="sortChange"
      :seek="seek"
    >
      <span
        slot="slot"
        slot-scope="scope"
        style="color:#409eff;font-size:15px;"
        >{{ scope.scope.$index }}</span
      >
    </TableComponent>
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"
    ></pagination>
    <!-- 添加编辑 -->
    <cont-dialog ref="contDialog" @updateList="queryKeyword"></cont-dialog>
  </div>
</template>
<script>
import { PublicComponent } from "@/mixins/common";
import { alarmContact } from "@/mixins/alarmContact";
import pagination from "@/components/pagination";
import TableComponent from "@/components/TableComponent/index";
import { Columns, ColuumnsButton } from "./tableConfig";
import {
  getAlarmContact,
  deleteAlarmContact,
  queryContact,
} from "@/api/cloudMonitor/alarmList";
import contDialog from "./components/contDialog";
import { getPermission } from "@/cookie/cookie";

export default {
  components: {
    TableComponent,
    pagination,
    contDialog,
  },
  mixins: [PublicComponent, alarmContact],
  data() {
    return {
      Columns,
      ColuumnsButton,
      seek: {
        name: "",
        phone: "",
        email: "",
        wechat: "",
        sortNum: "",
      },
      Permission: [],
    };
  },
  mounted() {
    // this.getList()
    this.queryKeyword();
    this.Permission = getPermission();
  },
  methods: {
    queryKeyword() {
      let params = {
        current: this.offset,
        size: this.limit,
        name: this.seek.name ? this.seek.name : undefined,
        phone: this.seek.phone ? this.seek.phone : undefined,
        email: this.seek.email ? this.seek.email : undefined,
        wechat: this.seek.wechat ? this.seek.wechat : undefined,
        sortNum: this.seek.sortNum ? this.seek.sortNum : undefined,
      };
      queryContact(params).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data;
          this.contactList = data.records;
          if (this.contactList.length > 0) this.contactList.unshift({});
          this.total = data.total;
        }
      });
      // this.getList()
    },
    sortChange(column, prop) {
      if (prop == "name") {
        if (column.order == "descending") {
          this.seek.sortNum = 2;
        } else {
          this.seek.sortNum = 1;
        }
      } else if (prop == "phone") {
        if (column.order == "descending") {
          this.seek.sortNum = 4;
        } else {
          this.seek.sortNum = 3;
        }
      } else if (prop == "email") {
        if (column.order == "descending") {
          this.seek.sortNum = 6;
        } else {
          this.seek.sortNum = 5;
        }
      } else if (prop == "wechat") {
        if (column.order == "descending") {
          this.seek.sortNum = 8;
        } else {
          this.seek.sortNum = 7;
        }
      } else {
        this.seek.sortNum = "";
      }
    },
    contactDelete(row) {
      deleteAlarmContact(row.id)
        .then((res) => {
          if (res.data.code === 0) {
            this.$message.success(this.$t("lang.Button.successDelete"));
            this.offset = 1;
            this.queryKeyword();
          } else {
            this.$message.error(this.$t("lang.collect.msg8"));
          }
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>
